export const assembleHexWithAlpha = chromePickerEvent => {
  const { hex, rgb } = chromePickerEvent;
  let alpha = Math.round(rgb.a * 255).toString(16);
  if (alpha.length < 2) alpha = `0${alpha}`;
  return hex + alpha;
};
